import CardBody from './cardBody-TEMPLATE_VERSION'

export default CardBody
